
import { Injectable, InjectionToken, Injector, inject } from '@angular/core';
import { MSAL_BROADCAST_CONFIG, MsalBroadcastService, MsalService } from '@azure/msal-angular';

import { IPublicClientApplication } from '@azure/msal-browser';
import { Location } from '@angular/common';
import { Brand } from 'app/brand-config';
import { DynamicMsalService, msalInstanceFactory } from './dynamic-msal.service';

export const DYNAMIC_MSAL_INSTANCE: InjectionToken<IPublicClientApplication> = new InjectionToken<IPublicClientApplication>('DYNAMIC_MSAL_INSTANCE');

@Injectable({ providedIn: 'root' })
export class MsalFactoryService {
  private injector = inject(Injector);
  
  private msalServices: { [key in Brand]?: MsalService } = {};
  private dynamicMsalServices: { [key in Brand]?: DynamicMsalService } = {};
  private msalBroadcastServices: { [key in Brand]?: MsalBroadcastService } = {};

  getMsalService(type: Brand): MsalService {
    if (!this.msalServices[type]) {
      const dynamicInjector = Injector.create({
        providers: [
          {
            provide: Location,
            useClass: Location,
          },
          {
            provide: DYNAMIC_MSAL_INSTANCE,
            useFactory: () => msalInstanceFactory(type),
          },
          {
            provide: MsalService,
            useClass: MsalService,
            deps: [DYNAMIC_MSAL_INSTANCE, Location, Injector],
          },
          {
            provide: MSAL_BROADCAST_CONFIG,
            useValue: {}, 
          },
          {
            provide: MsalBroadcastService,
            useClass: MsalBroadcastService,
            deps: [DYNAMIC_MSAL_INSTANCE, MSAL_BROADCAST_CONFIG],
          }
        ],
        parent: this.injector,
      });

      this.msalServices[type] = dynamicInjector.get(MsalService);
    }
    return this.msalServices[type];
  }

  getDynamicMsalService(type: Brand): DynamicMsalService {
    if (!this.dynamicMsalServices[type]) {
      const msalService = this.getMsalService(type);
      this.dynamicMsalServices[type] = new DynamicMsalService(msalService);
    }
    return this.dynamicMsalServices[type];
  }

  getMsalBroadcastService(type: Brand): MsalBroadcastService {
    if (!this.msalBroadcastServices[type]) {
      this.getMsalService(type);
      const dynamicInjector = Injector.create({
        providers: [
          {
            provide: DYNAMIC_MSAL_INSTANCE,
            useFactory: () => msalInstanceFactory(type),
          },
          {
            provide: MSAL_BROADCAST_CONFIG,
            useValue: {},
          },
          {
            provide: MsalBroadcastService,
            useClass: MsalBroadcastService,
            deps: [DYNAMIC_MSAL_INSTANCE, MSAL_BROADCAST_CONFIG],
          }
        ],
        parent: this.injector,
      });
      
      this.msalBroadcastServices[type] = dynamicInjector.get(MsalBroadcastService);
    }
    return this.msalBroadcastServices[type];
  }
}